import React from 'react'
import { useTheme } from '@shared/lib'

const MtsIcon = () => {
  const theme = useTheme()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" width="16" height="16">
      <path fill="#FF0032" d="M.5 0h16v16H.5z" />
      <path
        fill={theme.colors.icon.primary}
        d="M10.768 2.215v.64h1.373V5.404h.77V2.856h1.373v-.64h-3.516ZM5.82 2.225 4.817 4.32 3.812 2.225H2.715v3.168h.769V3.126l.982 1.915h.7l.983-1.915v2.267h.769V2.225H5.821ZM13.513 12.785a.528.528 0 0 1-.15.309.643.643 0 0 1-.308.155 2.423 2.423 0 0 1-.509.047 1.66 1.66 0 0 1-.536-.08.668.668 0 0 1-.348-.263c-.084-.124-.126-.304-.126-.533v-.325c0-.23.043-.41.126-.535a.668.668 0 0 1 .347-.263c.173-.056.354-.083.536-.08.171-.002.342.014.51.047.114.023.22.077.307.156a.527.527 0 0 1 .15.309h.77a1.127 1.127 0 0 0-.264-.663 1.204 1.204 0 0 0-.578-.354 3.24 3.24 0 0 0-.894-.107c-.369 0-.689.053-.95.158-.26.1-.477.286-.616.528-.135.234-.207.546-.211.929V12.292c.005.382.076.695.211.928.14.242.356.428.615.529.262.105.583.158.95.158.302.006.604-.03.895-.108a1.2 1.2 0 0 0 .578-.354c.157-.186.25-.419.264-.662l-.769.002Z"
      />
    </svg>
  )
}

export default MtsIcon
